<template>
  <div class="container-fluid my-3 target" style="min-height:50vh">
    <div class="row">
      <div class="col-12">
        <div class="d-flex menu">
          <div @click="goRecordTypePage('summary')"  class="title d-sm-flex pointer" :class="{'active' : ToeicRecordType === 'summary'}">
            <div class="my-auto toeic-menu-label" data-label="成績總表">
              多益口說成績總表
            </div>
          </div>
          <div @click="goRecordTypePage('personal')" class="title  d-sm-flex pointer" :class="{'active' : ToeicRecordType === 'personal'}">
            <div class="my-auto toeic-menu-label" data-label="個人紀錄">
              多益Bridge成績總表
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 d-md-flex my-3 justify-content-between align-items-center">
        <div class="d-flex  align-items-center toeic-filter-row">
          <div>
            <label class="m-0 mr-2">考試類型:</label>
            <select v-model="examTypeSelected">
              <option value="gept">GEPT 初級</option>
              <option value="gept-middle">GEPT 中級</option>
              <option value="toeic">多益口說</option>
              <option value="toeic_bridge">多益Bridge</option>
            </select>
          </div>
          <div v-if="isGEPTExam">
            <label class="m-0 mr-2">測驗類型:</label>
            <select v-model="typeSelected">
              <option value="speaking">口說</option>
              <option value="writing">寫作</option>
            </select>
          </div>
          <div v-if="ToeicRecordType === 'summary'" >
            <label class="m-0 mr-2">測驗名稱:</label>
            <select v-model="examSelected">
              <option value="0" disabled selected>請選擇測驗名稱</option>
              <option v-for="(item, index) in examList" :key="index" :value="item.id">
                <span>
                  {{ item.name }}
                </span>
              </option>
            </select>
          </div>
          <div v-if="ToeicRecordType === 'personal'">
            <label class="m-0 mr-2">學生:</label>
            <select v-model="studentSelected">
              <option value="0" disabled selected>請選擇學生</option>
              <option v-for="(item, index) in studentList" :key="index" :value="item.id">
                <span>
                  {{ item.name }}
                </span>
              </option>
            </select>
          </div>
          <div v-if="ToeicRecordType === 'personal'">
            <label class="m-0 ml-4 mr-2">測驗名稱:</label>
            <select v-model="examSelected">
              <option value="0" disabled selected>All</option>
              <option v-for="(item, index) in examList" :key="index" :value="item.id">
                <span>
                  {{ item.name }}
                </span>
              </option>
            </select>
          </div>
          <div v-if="ToeicRecordType === 'summary'" class="ml-4">
            <div class="d-flex align-items-center">
              <label class="m-0 mr-2">區間:</label>
              <date-picker :clearable="false" valueType="format" v-model="range" type="date" range placeholder="請選擇日期區間"></date-picker>
            </div>
          </div>
        </div>
      </div>
      <div v-if="ToeicRecordType === 'summary'" class="col-12" style="min-height:40vh">
        <div>
          <table class="rwd-table mt-3">
            <tbody>
              <tr>
                <th>帳號</th>
                <th>姓名</th>
                <th>測驗名稱</th>
                <th>測驗時間</th>
                <th>最新成績</th>
              </tr>
              <tr v-for="(item, index) in examSummary" :key="index">
                <td class="rwd-td" data-th="帳號">
                  {{item.email}}
                </td>
                <td data-th="姓名">
                  {{item.name}}
                </td>
                <td data-th="測驗名稱">
                  {{item.exam_name}}
                </td>
                <td data-th="測驗時間">
                  {{item.date}}
                </td>
                <td data-th="最新成績">
                  {{item.score}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="examSummary.length===0" class="remind mt-5">
          <h3>{{this.dataInfo}}</h3>
        </div>
      </div>
      <div v-else class="col-12" style="min-height:40vh">
        <div>
          <table class="rwd-table mt-3">
            <tbody>
              <tr>
                <th>測驗名稱</th>
                <th>測驗時間</th>
                <th>成績</th>
                <th>詳細資料</th>
              </tr>
              <tr v-for="(item, index) in studentRecord" :key="index">
                <td class="rwd-td" data-th="測驗名稱">
                  {{item.exam_name}}
                </td>
                <td class="rwd-td" data-th="測驗時間">
                  {{item.date}}
                </td>
                <td data-th="成績">
                  {{item.score}}
                </td>
                <td data-th="詳細資料">
                  <a href="javascript:void();" @click="goPage(item.record_id)"> 詳細資料</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="studentRecord.length===0" class="remind mt-5">
          <h3>無考試資料</h3>
        </div>
      </div>
      <pagination v-if="(pageCount > 1 && examSummary?.length > 0) || (pageCount > 1 && studentRecord?.length > 0)" class="m-auto pt-4" :current="pageIndex" :total="pageCount" v-on:page="toPage"/>
		</div>
  </div>
</template>
<script>
// @ is an alias to /src
import Pagination from '@/components/Pagination.vue'
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import api from '../../../store/api'
export default {
  name: 'Exam-summary',
  data () {
    return {
      examSummary: [],
      examSelected: 0,
      studentSelected: 0,
      examList: [],
      studentList: [],
      studentRecord: [],
      range: [ moment(new Date(new Date().getTime())).format('YYYY-MM-DD'), moment(new Date()).format('YYYY-MM-DD')],
      title: this.$route.name,
      examTypeSelected: this.getExamTypeByRoute(this.$route.name),
      typeSelected: 'speaking',
      pageIndex: 1,
      pageCount: 0,
      dataInfo: '請選擇測驗名稱'
    }
  },
  computed: {
    groupId () {
      return this.$route.params.groupId
    },
    ToeicRecordType () {
      if (this.$route.name.includes('Summary')) {
        return 'summary'
      } else {
        return 'personal'
      }
    },
    ExamType () {
      if (this.isGEPTExam) {
        return 'gept'
      }
      return this.examTypeSelected
    },
    isGEPTExam () {
      return this.examTypeSelected.includes('gept')
    },
    GEPTLevelType () {
      if (this.examTypeSelected === 'gept-middle') {
        return '中級'
      }
      if (this.examTypeSelected === 'gept') {
        return '初級'
      }
      return ''
    }
  },
  mounted () {
    this.getExamList()
    this.getStudentList()
  },
  watch: {
    examSelected (val) {
      this.dataInfo = '無考試資料'
      if (this.ToeicRecordType==='summary') {
        this.getExamSummary ()
      } else {
        this.getPersonalRecord()
      }
    },
    studentSelected (val) {
      if (val === 0) return
      this.getPersonalRecord()
    },
    range (val) {
      this.getExamSummary()
    },
    examTypeSelected (val) {
      const routeName = this.getExamRouteName(this.ToeicRecordType, val)
      if (this.title === routeName) {
        this.resetRecordData()
        this.getExamList()
        return
      }
      this.goExamTypePage(val)
    },
    async typeSelected () {
      if (!this.isGEPTExam) return
      this.resetRecordData()
      await this.getExamList(false)
      if (this.ToeicRecordType === 'personal' && this.studentSelected !== 0) {
        this.getPersonalRecord()
      }
    },
    '$route.name' (val) {
      this.title = val
      this.examTypeSelected = this.getExamTypeByRoute(val, this.examTypeSelected)
      this.resetRecordData()
      this.getExamList()
    },
  },
  methods: {
    async getExamList (clearStudent = true) {
      if (clearStudent) this.studentSelected = 0
      const { data } = await api.get(`/assessments/list/options/exam/${this.ExamType}`)
      this.examList = this.filterExamList(data)
    },
    filterExamList (list) {
      if (!this.isGEPTExam) {
        return list
      }
      return list.filter(item => item.type === this.GEPTLevelType)
    },
    async getStudentList () {
      const params = {
        pageSize: 5000
      }
      const { data } = await api.get(`/groups/${this.groupId}/students`, { params })
      this.studentList = data.data
    },
    toPage (toPage) {
      this.pageIndex = toPage
      if (this.ToeicRecordType==='summary') {
        this.getExamSummary ()
      } else {
        this.getPersonalRecord()
      }
    },
    async getExamSummary() {
      if (this.examSelected === 0) {
        return
      }
      const params = {
        exam_id: this.examSelected,
        group_id: this.groupId,
        begin_at: this.range[0] + ' 00:00:00',
        end_at:  this.range[1] + ' 23:59:59',
        page: this.pageIndex
      }
      if (this.isGEPTExam) {
        params.skill = this.typeSelected
      }
      const { data } = await api.get(`assessments/list/accounts`, { params })
      this.examSummary = data.data
      this.pageIndex = data.page_index
      this.pageCount = data.page_count
      if (data.data.length === 0 ) {
        this.dataInfo = '無考試資料'
      }
    },
    async getPersonalRecord() {
      const params = {
        exam_id: this.examSelected,
        group_id: this.groupId,
        student_id: this.studentSelected,
        type: this.ExamType,
        page: this.pageIndex
      }
      if (this.isGEPTExam) {
        params.skill = this.typeSelected
      }
      const { data } = await api.get(`assessments/list/records`, { params })
      this.studentRecord = data.data
      this.pageIndex = data.page_index
      this.pageCount = data.page_count
      if (data.data.length === 0 ) {
        this.dataInfo = '無考試資料'
      }
    },
    goPage (id) {
      if (this.isGEPTExam) {
        const routeData = this.$router.resolve({
          name: 'gept_report_formal',
          params: {
            record_id: id
          }
        })
        window.open(routeData.href, '_blank')
        return
      }
      const routeData = this.$router.resolve({
        name: 'TOEIC_report',
        params: {
          practice_type: 'speaking',
          record_id: id
        }
      })
      window.open(routeData.href, '_blank')
    },
    getExamTypeByRoute(routeName, currentType = 'gept') {
      if (routeName === 'Exam-Summary' || routeName === 'Exam-Personal') {
        return currentType && currentType.includes('gept') ? currentType : 'gept'
      }
      if (routeName && routeName.includes('Bridge')) {
        return 'toeic_bridge'
      }
      if (routeName && routeName.includes('Toeic')) {
        return 'toeic'
      }
      return 'gept'
    },
    getExamRouteName(recordType = this.ToeicRecordType, examType = this.examTypeSelected) {
      if (examType && examType.includes('gept')) {
        return recordType === 'summary' ? 'Exam-Summary' : 'Exam-Personal'
      }
      if (recordType === 'summary') {
        return examType === 'toeic_bridge' ? 'Exam-Bridge-Summary' : 'Exam-Toeic-Summary'
      }
      return examType === 'toeic_bridge' ? 'Exam-Bridge-Personal' : 'Exam-Toeic-Personal'
    },
    goRecordTypePage(recordType) {
      const routeName = this.getExamRouteName(recordType, this.examTypeSelected)
      if (this.title === routeName) return
      this.$router.push({ name: routeName, params: { groupId: this.groupId } })
    },
    goExamTypePage(examType) {
      const routeName = this.getExamRouteName(this.ToeicRecordType, examType)
      if (this.title === routeName) return
      this.$router.push({ name: routeName, params: { groupId: this.groupId } })
    },
    resetRecordData() {
      this.examList = []
      this.examSelected = 0
      this.examSummary = []
      this.studentRecord = []
      this.pageIndex = 1
      this.pageCount = 0
      this.dataInfo = '請選擇測驗名稱'
    },
    goTitlePage(el) {
      // 如果傳入的 el 和當前的 title 一樣，就直接 return
      if (this.title === el) return
      this.title = el
      this.examList = []
      if (el) {
        this.$router.push({ name: el, params: { groupId: this.groupId } })
      }
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    export2Excel (list) {
      require.ensure([], () => {
        const { export_json_to_excel } = require('../../../vendor/Export2Excel')
        const tHeader = [ '學生姓名', '最近學習日期', '學習時間', '第一次成績', '練習次數','口說成績' ]
        const filterVal = [ 'name', 'recent', 'time', 'first_score' , 'finish_speak_count', 'score', ]
        const data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, '學習紀錄')
      })
    },
    async downloadExcel () {
      const params = {
        page: this.pageIndex,
        pageSize: 1000
      }
      const { data } = await api.get(`records/groups/${this.groupId}/voices/courses/${this.examSelected}`, { params })
      this.export2Excel(data.data)
    }
  },
  components: {
    Pagination,
    DatePicker
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/styles/color.scss";
  .menu {
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    .title {
      margin: 10px 30px 10px 0;
    }
  }
  .toeic-menu-label {
    font-size: 0;
    &::before {
      content: attr(data-label);
      font-size: 1rem;
    }
  }
  .toeic-filter-row {
    flex-wrap: wrap;
    gap: 12px 24px;
  }
  .active {
    // color: red;
    font-weight: bolder;
  }
  .target-box {
    // width: 270px;
    height: 180px;
    overflow: hidden;
    background-color: #ededed;
    border: .5px solid rgb(202, 202, 202);
    border-radius: 5px;
    .target-title {
      padding: 8px;
      background-color: #0041b9;
      color: #fff;
    }
    .target-content {
      text-align: left;
      padding: 20px;
      height: 80%;
    }
    .progress {
      margin: 5px;
      height: 10px;
      background-color: #fff;
      .progress-bar {
        background-color: red;
      }
    }
  }
  table {
    border-collapse: collapse;
    width: 100%;
    overflow: auto;
  }
  th {
    overflow:hidden;
    color: #fff;
    text-align: center !important;
    padding: 8px;
  }
  tr:nth-child(even){
    background-color:#e8e8e8 !important;
  }
  /*表格中的奇數對 tr*/
  tr:nth-child(odd){
    background-color:#d8d8d8 !important;
  }
  td {
    font-weight: bold;
    // background-color: rgb(230, 230, 230);
    border: 4px solid #fff;
    text-align: center !important;
    padding: 8px;
  }

  .title-box {
    margin-bottom: 20px;
    border-top: #aaa solid 1px;
    border-bottom: #aaa solid 1px;
    padding: 10px 0;
    .title {
      color: #aaa;
      margin: 0 50px 0 0;
      cursor: pointer;
    }
    .active {
      color: black;
    }
  }
  .rwd-table {
  margin: auto;
  min-width: 300px;
  max-width: 100%;
  border-collapse: collapse;
}

.rwd-table tr:first-child {
  border-top: none;
  background: $table-gray !important;
  color: #fff;
}

.rwd-table tr {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #f5f9fc;
}

.rwd-table tr:nth-child(odd):not(:first-child) {
  background-color: #ebf3f9;
}

.rwd-table tbody th {
  display: none;
}

.rwd-table td {
  display: block;
}

.rwd-table td:first-child {
  margin-top: .5em;
}

.rwd-table td:last-child {
  margin-bottom: .5em;
}

.rwd-table td:before {
  content: attr(data-th) ": ";
  font-weight: bold;
  width: 120px;
  display: inline-block;
  color: #000;
}

.rwd-table th,
.rwd-table td {
  text-align: left;
}

.rwd-table tr {
  border-color: #bfbfbf;
}

.rwd-table th,
.rwd-table td {
  padding: .5em 1em;
}
.main-title {
  background: rgb(24, 97, 255);
  border: none !important;
}

@media screen and (max-width: 601px) {
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
  .rwd-td {
    display: block !important;
    background-color: #04a2d6;
  }
  td {
    border: 1px solid #ccc;
  }
}
.lesson-box {
  width: 80%;
}
.group-box {
  width: 20%;
}
.box {
  margin: 5px;
  padding: 10px;
  background-color: #044ed6;
  color: #fff;
}
@media screen and (min-width: 600px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }
  .rwd-table tbody th,
  .rwd-table td {
    display: table-cell;
    padding: .25em .5em;
  }
  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }
  .rwd-table th,
  .rwd-table td {
    // padding: 1em !important;
  }
}
</style>
